import text from "components/results/analysis-results/text";
import {
  AnalysisItem,
  LayerGroupType,
  LegendItem,
  LocationData
} from "helpers/models";
import { Content } from "pdfmake/interfaces";
import aggregationDetail from "report/common/aggregation-detail";
import aggregationDetailFathom from "report/common/aggregation-detail-fathom";
import filterLayerId from "report/common/filter-layer-id";
import gap from "report/common/gap";
import groupLayerDefend from "report/common/group-layer-defend";
import groupByLayerIdValueLabel from "report/common/group-layer-value";
import page from "report/common/page";
import transformRule from "report/common/rule";
import sortRowFathom from "report/common/sort-row-fathom";
import sortRowLegend from "report/common/sort-row-legend";
import getTitle from "report/common/title";
import getTpye from "report/common/type";
import getFathom from "./detail/fathom";
import getOther from "./detail/other";
import getOverview from "./overview/overview";
import legendLayerSubtitle from "report/common/legend-layer-subtitle";

const get = async (
  t: any,
  locationSet: LocationData,
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[],
  count: number,
  aggregationUnits: string[],
  unit: string,
  currency: string
): Promise<Content[]> => {
  const legend: LayerGroupType = transformRule(legendItems);

  const groupData = groupByLayerIdValueLabel(
    analysisItems.filter((e) => !e.layerId.includes("Fathom"))
  );

  // const idArrayOther = filterLayerId(groupData);

  // idArrayOther.forEach((id) => {
  //   delete groupData[id];
  // });

  const groupDetail = aggregationDetail(
    groupData,
    locationSet.items || [],
    legend,
    aggregationUnits
  );

  sortRowLegend(groupDetail, legend);

  const groupedResultFathom = groupLayerDefend(
    analysisItems.filter((e) => e.layerId.includes("Fathom"))
  );

  // const idArrayFathom = filterLayerId(groupedResultFathom);

  // idArrayFathom.forEach((id) => {
  //   delete groupedResultFathom[id];
  // });

  const groupDetailFathom = aggregationDetailFathom(
    groupedResultFathom,
    locationSet.items || [],
    legend,
    aggregationUnits
  );

  sortRowFathom(groupDetailFathom);

  // const idArray = [...idArrayFathom, ...idArrayOther];

  const layerTitle = legendLayerSubtitle(legendItems);

  return [
    getTpye(t("report.hazard"), 802),
    gap(30),
    await getOverview(
      t,
      locationSet.items || [],
      analysisItems,
      legendItems,
      aggregationUnits,
      currency
    ),
    // gap(30),
    // text(t, idArray),
    page(),
    Object.keys(groupDetailFathom).length || Object.keys(groupDetail).length
      ? getTitle(t("report.analysis"))
      : [],
    gap(10),
    Object.keys(groupDetailFathom).length
      ? getFathom(
          t,
          groupDetailFathom,
          aggregationUnits,
          unit,
          currency,
          layerTitle
        )
      : [],
    Object.keys(groupDetail).length
      ? getOther(t, groupDetail, aggregationUnits, unit, currency, layerTitle)
      : []
  ];
};

export default get;
